/*global VXConfig*/

import React                from 'react';
import PropTypes            from 'prop-types';
import cx                   from 'classnames';
import LanguageSelector     from './LanguageSelector';
import {
    generateKey,
    openCookieConsent,
    urlWithQuery
}                           from "../../utils/CommonUtils";
import Translations         from '../../utils/Translations';
import SurveyFeedbackButton from '../Survey/SurveyFeedbackButton';
import ReloadHelper         from "../../utils/ReloadHelper";
import {
    getSeoHeadlineTranslation,
    getCommonTranslation
}                           from "../../utils/TranslationHelper";
import Flux                 from "../../flux/Flux";
import {trackFooterClick}   from '../../utils/GAHelper';
import {VXPay}              from './../../utils/VXPay';


function getLanguage() {
    let language = (VXConfig.language).toUpperCase();
    if (language !== 'DE' && language !== 'EN' && language !== 'ES') {
        language = 'EN';
    }
    return language;
}

class Footer extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state    = {
            top10SexoleGirls: [],
        };
        this.isSexole = Flux.Browser.isSexole();
    }

    componentDidMount() {
        this.isSexole && this.getTop10SexoleGirls();
    }

    getTop10SexoleGirls() {
        const args = {
            collectionNames: ['spanish'],
            firstModels:     10,
        };
        Flux.CollectionsV2.getCollections({...args}, (res) => {
            if (res.data.collections_v2.length > 0) {
                const models = res.data.collections_v2[0].models.items;
                this.setState({
                    top10SexoleGirls: models
                });
            }
        });
    }

    openCookie(event) {
        event.preventDefault();
        trackFooterClick('cookies');
        openCookieConsent();
    }

    reloadWithPjax(url, e) {
        e.preventDefault();
        ReloadHelper.reloadWithPjax(url, e);
    }

    openVXPaySettings(e) {
        e.preventDefault();
        trackFooterClick('abosettings', '#');
        VXPay.openSettings();
    }

    render() {
        const language               = getLanguage();
        const today                  = new Date();
        const socialLinks            = Flux.FooterLinks.getSocialLinks();
        const socialIcons            = Flux.FooterLinks.getSocialIcons();
        const zendeskLink            = Flux.FooterLinks.getZendeskLink(language);
        const VxCashLink             = Flux.FooterLinks.getVxCashLink();
        const becomeAVisitXModelLink = Flux.FooterLinks.getBecomeAVisitXModelLink(language);
        let SEOText                  = null;
        const withdrawalLink         = urlWithQuery(this.props.config.termsLink, {scrollTo: 'widerruf'});
        const reportContentLink      = Flux.FooterLinks.getReportContentLink(language);

        if (Flux.Browser.isSpanishPfm()) {
            const sexoleTopModelsHTML = this.state.top10SexoleGirls.map((girl, index, array) => (
                    `<span key=${generateKey(girl.name, index)}><a class='footer-seo-texts__text footer-seo-texts__text--link' href=${girl.linkVX}>${girl.name}</a>${index === array.length - 1 ? '' : ', '}</span>`
            )).join("");

            SEOText = (
                    <div className={`footer-seo-texts__container`}>
                        <div className={'footer-seo-texts__content'}>
                            <div className={'footer-seo-texts__text-block'}>
                                <h4 className="footer-seo-texts__text footer-seo-texts__text--header">{this.isSexole ? Translations.get('SexoleHomepageSEO1-header') : Translations.get('SpanishHomepageSEO1-header')}</h4>
                                <p className="footer-seo-texts__text footer-seo-texts__text--body"
                                   dangerouslySetInnerHTML={{__html: this.isSexole ? Translations.get('SexoleHomepageSEO1-body', sexoleTopModelsHTML) : Translations.get('SpanishHomepageSEO1-body')}}
                                />

                            </div>
                            <div className={'footer-seo-texts__text-block'}>
                                <h4 className="footer-seo-texts__text footer-seo-texts__text--header">{this.isSexole ? Translations.get('SexoleHomepageSEO2-header') : Translations.get('SpanishHomepageSEO2-header')}</h4>
                                <p className="footer-seo-texts__text footer-seo-texts__text--body">{this.isSexole ? Translations.get('SexoleHomepageSEO2-body') : Translations.get('SpanishHomepageSEO2-body')}</p>
                            </div>
                        </div>
                    </div>
            );
        }

        const sinceText = this.props.config.yearsOnline + ' ' + Translations.get('FooterLblYears') + ' ' + Translations.get('And') + ' ' + this.props.config.monthOnline + ' ' + (parseInt(this.props.config.monthOnline) === 1 ? Translations.get('DateMonth') : Translations.get('FooterLblMonths'));

        return (
                <div className="row footer">
                    {Flux.Browser.isSpanishPfm() && SEOText}
                    <div className="h-text-align-center">
                        <a href="/" className="footer__logo" onClick={() => trackFooterClick('logo', '/')}>
                            <img src={this.isSexole ? "/assets/img/sexole/sexole_x_visit-x_logo.svg" : "/assets/img/logo2.svg"}
                                 width="187"
                                 alt={"VISIT-X | " + Translations.get('SeoTitleActorSearch')}
                            />
                        </a>

                        {!this.props.config.isActorSearchRoute && !this.props.config.isActorSearchRoute && !this.isSexole &&
                                <h2>
						<span className="footer__text">
							{getSeoHeadlineTranslation('homepage_footersince_h2')}&nbsp;
						</span>
                                    <span className="footer__highlight-text">{sinceText}</span>
                                </h2>
                        }
                    </div>

                    <div className="col-xs-12 h-text-align-center">
                        <div className="footer__buttoncontainer">
                            <div className="footer__button">
                                <a className="btn--icon -icon-support-line -btn-color-footer -height-footer -click-material h-width-full"
                                   href={zendeskLink}
                                   rel="nofollow"
                                   target="_blank"
                                   onClick={() => trackFooterClick('service')}
                                >{Translations.get('FooterLabelSupport')}</a>
                            </div>

                            <div className="footer__button">
                                <div id="footer-button-feedback" className="h-pos-relative">
                                    <SurveyFeedbackButton callback={() => trackFooterClick('feedback')} />
                                </div>
                            </div>

                            <div className="footer__dropdown hidden-md-down">
                                <div className="h-pos-relative js-language-selector">
                                    <LanguageSelector initLanguage={this.props.config.initLanguage} languageLinks={this.props.config.languageLinks} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 h-text-align-center">
                        <div className="footer__buttoncontainer -no-margin-top">
                            <div className="footer__button">
                                <a className={(this.isSexole ? "" : "-icon-visitx-logo-single") + " btn--icon -btn-color-footer -height-footer -click-material h-width-full"}
                                   href="#"
                                   target="_blank"
                                   onClick={this.openVXPaySettings}
                                >{Translations.get('FooterAboSettings')}</a>
                            </div>

                            <div className="footer__button">
                                <a className={"btn--icon -icon-girl-full -btn-color-footer -height-footer -click-material h-width-full"}
                                   href={becomeAVisitXModelLink} target="_blank"
                                   onClick={() => trackFooterClick('becamgirl', becomeAVisitXModelLink)}
                                >{Translations.get('FooterBecomeAVisitXModel')}</a>
                            </div>

                            <div className="footer__button">
                                <a className={(this.isSexole ? "" : " -icon-visitx-logo-single") + " btn--icon -btn-color-footer -height-footer -click-material h-width-full"}
                                   href={VxCashLink}
                                   target="_blank"
                                   onClick={() => trackFooterClick('partner', VxCashLink)}
                                >{Translations.get('FooterLabelAffiliate')}</a>
                            </div>

                            <div className="footer__dropdown hidden-lg-up">
                                <div className="h-pos-relative js-language-selector">
                                    <LanguageSelector initLanguage={this.props.config.initLanguage} languageLinks={this.props.config.languageLinks} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.props.config.showCategories &&
                            [<div key={generateKey('categories-header')} className="col-xs-12 h-text-align-center">
                                 <p className="footer__text -width-margin">{Translations.get('FavouriteCategories')}:</p>
                             </div>,
                             <div key={generateKey('categories-list')} className="col-xs-12 h-text-align-center">
                                 <a className="footer__link -link-category"
                                    href={this.props.config.bdsmLink.link}
                                    onClick={(e) => {
                                        trackFooterClick('tag_bdsm', this.props.config.bdsmLink.link);
                                        this.reloadWithPjax(this.props.config.bdsmLink.link, e);
                                    }}
                                 >{this.props.config.bdsmLink.title}</a>
                                 {
                                     this.isSexole
                                             ?
                                             <a className="footer__link -link-category"
                                                href={this.props.config.spanishLink}
                                                onClick={(e) => {
                                                    trackFooterClick('cat_spanish', this.props.config.spanishLink);
                                                    this.reloadWithPjax(this.props.config.spanishLink, e);
                                                }}
                                             >{Translations.get('cams_categories.collection_label_spanish')}</a>
                                             :
                                             <a className="footer__link -link-category"
                                                href={this.props.config.analLink.link}
                                                onClick={(e) => {
                                                    trackFooterClick('tag_anal', this.props.config.analLink.link);
                                                    this.reloadWithPjax(this.props.config.analLink.link, e);
                                                }}
                                             >{this.props.config.analLink.title}</a>
                                 }
                                 <a className="footer__link -link-category"
                                    href={this.props.config.blowjobLink.link}
                                    onClick={(e) => {
                                        trackFooterClick('tag_blowjob', this.props.config.blowjobLink.link);
                                        this.reloadWithPjax(this.props.config.blowjobLink.link, e);
                                    }}
                                 >{this.props.config.blowjobLink.title}</a>
                                 <a className="footer__link -link-category"
                                    href={this.props.config.pornstarLink.link}
                                    onClick={(e) => {
                                        trackFooterClick('tag_pornstar', this.props.config.pornstarLink.link);
                                        this.reloadWithPjax(this.props.config.pornstarLink.link, e);
                                    }}
                                 >{this.props.config.pornstarLink.title}</a>
                                 <a className="footer__link -link-category"
                                    href={this.props.config.dirtytalkLink.link}
                                    onClick={(e) => {
                                        trackFooterClick('tag_dirtytalk', this.props.config.dirtytalkLink.link);
                                        this.reloadWithPjax(this.props.config.dirtytalkLink.link, e);
                                    }}
                                 >{this.props.config.dirtytalkLink.title}</a>
                                 <a className="footer__link -link-category"
                                    href={this.props.config.dominaLink.link}
                                    onClick={(e) => {
                                        trackFooterClick('tag_domina', this.props.config.dominaLink.link);
                                        this.reloadWithPjax(this.props.config.dominaLink.link, e);
                                    }}
                                 >{this.props.config.dominaLink.title}</a>
                             </div>]}
                    {!this.isSexole && !Flux.Browser.isSpanishPfm() && <React.Fragment>
                        <div className="col-xs-12 h-text-align-center">
                            <p className="footer__text -width-margin">{getCommonTranslation('footer-blog-headline')}</p>
                        </div>
                        <div className="col-xs-12 h-text-align-center">
                            <a className="footer__link -link-category"
                               href={this.props.config.wankBlogPost ? this.props.config.wankBlogPost : '#'}
                               onClick={(e) => {
                                   trackFooterClick('click_bloglink', this.props.config.wankBlogPost, true);
                                   this.reloadWithPjax(this.props.config.wankBlogPost, e);
                               }}
                            >{getCommonTranslation('footer-blog-item')}</a>
                            <a className="footer__link -link-category"
                               href={this.props.config.wankBlogPost2 ? this.props.config.wankBlogPost2 : '#'}
                               onClick={(e) => {
                                   trackFooterClick('click_bloglink', this.props.config.wankBlogPost2, true);
                                   this.reloadWithPjax(this.props.config.wankBlogPost2, e);
                               }}
                            >{getCommonTranslation('footer-blog-item-2')}</a>
                        </div>
                    </React.Fragment>}
                    <div className="footer__line"></div>

                    <div className="footer-stats__wrapper">
                        <div className="footer-stats">
                            <div className="footer-stats__links">
								<span className="footer-stats__item">
									<i className="icon -icon-user-full footerstats__icon"></i>
                                    {this.props.config.allUsersCount + ' ' + Translations.get('FooterLblUser')}
								</span>
                                <span className="footer-stats__item">
									<i className="icon -icon-play-full footerstats__icon"></i>
                                    {this.props.config.allVideosCount + ' ' + Translations.get('FooterLblVideos')}
								</span>
                                <span className="footer-stats__item">
									<i className="icon -icon-camera-full footerstats__icon"></i>
                                    {this.props.config.allPicturesCount + ' ' + Translations.get('FooterLblImages')}
								</span>
                                <span className="footer-stats__item">
									<i className="icon -icon-girl-full footerstats__icon"></i>
                                    {this.props.config.allActorsCount + ' ' + Translations.get('FooterLblAmateurs')}
								</span>
                            </div>

                            <div className="footer-stats__socials">
                                {
                                    Object.keys(socialLinks).map((link, index) =>
                                                    <span key={index} className="footer-stats__item footer__social-links">
										<a
                                                href={socialLinks[link]}
                                                rel="nofollow me"
                                                target="_blank"
                                                onClick={() => trackFooterClick(link, socialLinks[link])}
                                        >
											<i className={cx('icon', socialIcons[link])} />
										</a>
									</span>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <nav className="col-xs-12">
                        <ul className="navigation--footer h-list--horizontal">
                            <li className="footer__list__item">
                                <a className="footer__link"
                                   href={this.props.config.termsLink}
                                   onClick={() => trackFooterClick('agb', this.props.config.termsLink)}
                                >{Translations.get('FooterLabelTermsOfService')}</a>
                            </li>
                            <li className="footer__list__item">
                                <a className="footer__link"
                                   href={this.props.config.imprintLink}
                                   onClick={() => trackFooterClick('impr', this.props.config.imprintLink)}
                                >{Translations.get('FooterLabelImprint')}</a>
                            </li>
                            <li className="footer__list__item">
                                <a className="footer__link"
                                   href={this.props.config.dataLink}
                                   onClick={() => trackFooterClick('ds', this.props.config.dataLink)}
                                >{Translations.get('FooterLabelDataProtection')}</a>
                            </li>
                            <li className="footer__list__item">
                                <a className="footer__link"
                                   href={withdrawalLink}
                                   onClick={() => trackFooterClick('withdr', withdrawalLink)}
                                >{Translations.get('FooterLabelWithdrawal')}</a>
                            </li>
                            <li className="footer__list__item">
                                <a className="footer__link js-cookie-consent"
                                   href="#"
                                   onClick={this.openCookie}
                                >{Translations.get('FooterLabelCookies')}</a>
                            </li>
                            <li className="footer__list__item">
                                <a className="footer__link js-cookie-consent"
                                   href={reportContentLink}
                                   rel="nofollow"
                                   target="_blank"
                                   onClick={() => trackFooterClick('report')}
                                >{Translations.get('FooterLabelReportContent')}</a>
                            </li>

                            <li className="footer__list__item">
                                <a className="footer__link"
                                   href={this.props.config.compilianceLink}
                                >{Translations.get('FooterLabelComplianceNotice2257')}</a>
                            </li>

                            <li className="footer__list__item">
                                &copy; {today.getFullYear()} - Made with <span className="icon -icon-heart-full h-color-highlight"></span> by VISIT-X in Amsterdam, NL
                            </li>
                        </ul>
                    </nav>
                </div>);
    }
}

Footer.propTypes = {
    config: PropTypes.shape({
        initLanguage:       PropTypes.string,
        languageLinks:      PropTypes.object,
        isActorSearchRoute: PropTypes.bool,
        yearsOnline:        PropTypes.number,
        monthOnline:        PropTypes.number,
        showCategories:     PropTypes.bool,
        vxModelsUrl:        PropTypes.string,
        allUsersCount:      PropTypes.string,
        allVideosCount:     PropTypes.string,
        allPicturesCount:   PropTypes.string,
        allActorsCount:     PropTypes.string,
        subRef:             PropTypes.string,
        platform:           PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        bdsmLink:           PropTypes.shape({link: PropTypes.string, title: PropTypes.string}),
        analLink:           PropTypes.shape({link: PropTypes.string, title: PropTypes.string}),
        blowjobLink:        PropTypes.shape({link: PropTypes.string, title: PropTypes.string}),
        pornstarLink:       PropTypes.shape({link: PropTypes.string, title: PropTypes.string}),
        dirtytalkLink:      PropTypes.shape({link: PropTypes.string, title: PropTypes.string}),
        dominaLink:         PropTypes.shape({link: PropTypes.string, title: PropTypes.string}),
        spanishLink:        PropTypes.string,
        termsLink:          PropTypes.string,
        imprintLink:        PropTypes.string,
        dataLink:           PropTypes.string,
        compilianceLink:    PropTypes.string,
        wankBlogPost:       PropTypes.string,
        wankBlogPost2:      PropTypes.string,
    }),
};


export default Footer;
